import { useEffect, useContext, useMemo, useState } from "react";
import axios from "axios";
import HeaderBar from "../../components/HeaderBar";
import PayRollLayoutWrapper from "../../components/PayRollLayoutWrapper";
import getCurrentSkin from "../../utils/getCurrentSkin";
import { ThemeContext } from "../../context/ThemeContext";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = "http://nissi-india.com";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

const ManagementLeaveCalculationView = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;

  const primaryBtnClass = `bg-${baseColor}-${baseShade}`;

  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState(null);

  const screenBadge = useMemo(() => "INFRA SCREEN : (MCL VIEW)", []);

  const cardBase =
    `rounded-3xl border shadow-xl overflow-hidden ` +
    (isDark
      ? "border-white/10 bg-gradient-to-br from-white/15 to-white/5 backdrop-blur-md"
      : "border-gray-200 bg-white");

  const textBase = isDark ? "text-gray-200" : "text-gray-800";

  const q = useQuery();
  const month = q.get("month") || "";
  const year = q.get("year") || "";

  const fetchMeta = async () => {
    if (!month || !year) {
      toast.warn("month and year are required in URL");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/api/management-leave-calculation-view/meta`, {
        params: { month, year },
      });

      if (res?.data?.success) {
        setMeta(res.data);
      } else {
        toast.error(res?.data?.message || "Failed to load formula.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Meta error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderRulesPanel = () => {
    if (!meta?.ruleKey) return null;

    const key = meta.ruleKey;

    // ✅ Same text as ASP
    if (key === "sun4mon31") return (
      <>
        <div>if present days is 4 ≤ present ≤ 7 then eligible days = 1</div>
        <div>if present days is 8 ≤ present ≤ 12 then eligible days = 2</div>
        <div>if present days is 13 ≤ present ≤ 16 then eligible days = 3</div>
        <div>if present days is 17 ≤ present ≤ 20 then eligible days = 4</div>
        <div>if present days is 21 ≤ present ≤ 24 then eligible days = 5</div>
        <div>if present days is 25 ≤ present ≤ 27 then eligible days = 6</div>
      </>
    );

    if (key === "sun4mon30") return (
      <>
        <div>if present days is 4 ≤ present ≤ 7 then eligible days = 1</div>
        <div>if present days is 8 ≤ present ≤ 11 then eligible days = 2</div>
        <div>if present days is 12 ≤ present ≤ 15 then eligible days = 3</div>
        <div>if present days is 16 ≤ present ≤ 19 then eligible days = 4</div>
        <div>if present days is 20 ≤ present ≤ 23 then eligible days = 5</div>
        <div>if present days is 24 ≤ present ≤ 27 then eligible days = 6</div>
      </>
    );

    if (key === "sun4mon29") return (
      <>
        <div>if present days is 4 ≤ present ≤ 7 then eligible days = 1</div>
        <div>if present days is 8 ≤ present ≤ 10 then eligible days = 2</div>
        <div>if present days is 11 ≤ present ≤ 14 then eligible days = 3</div>
        <div>if present days is 15 ≤ present ≤ 18 then eligible days = 4</div>
        <div>if present days is 19 ≤ present ≤ 22 then eligible days = 5</div>
        <div>if present days is 23 ≤ present ≤ 27 then eligible days = 6</div>
      </>
    );

    if (key === "sun4mon28") return (
      <>
        <div>if present days is 4 ≤ present ≤ 6 then eligible days = 1</div>
        <div>if present days is 7 ≤ present ≤ 10 then eligible days = 2</div>
        <div>if present days is 11 ≤ present ≤ 14 then eligible days = 3</div>
        <div>if present days is 15 ≤ present ≤ 17 then eligible days = 4</div>
        <div>if present days is 18 ≤ present ≤ 21 then eligible days = 5</div>
        <div>if present days is 22 ≤ present ≤ 27 then eligible days = 6</div>
      </>
    );

    if (key === "sun5mon31") return (
      <>
        <div>if present days is 3 ≤ present ≤ 6 then eligible days = 1</div>
        <div>if present days is 7 ≤ present ≤ 10 then eligible days = 2</div>
        <div>if present days is 11 ≤ present ≤ 13 then eligible days = 3</div>
        <div>if present days is 14 ≤ present ≤ 17 then eligible days = 4</div>
        <div>if present days is 18 ≤ present ≤ 20 then eligible days = 5</div>
        <div>if present days is 21 ≤ present ≤ 23 then eligible days = 6</div>
        <div>if present days is 24 ≤ present ≤ 27 then eligible days = 7</div>
      </>
    );

    if (key === "sun5mon30") return (
      <>
        <div>if present days is 3 ≤ present ≤ 6 then eligible days = 1</div>
        <div>if present days is 7 ≤ present ≤ 9 then eligible days = 2</div>
        <div>if present days is 10 ≤ present ≤ 13 then eligible days = 3</div>
        <div>if present days is 14 ≤ present ≤ 16 then eligible days = 4</div>
        <div>if present days is 17 ≤ present ≤ 19 then eligible days = 5</div>
        <div>if present days is 20 ≤ present ≤ 22 then eligible days = 6</div>
        <div>if present days is 23 ≤ present ≤ 27 then eligible days = 7</div>
      </>
    );

    if (key === "sun5mon29") return (
      <>
        <div>if present days is 3 ≤ present ≤ 5 then eligible days = 1</div>
        <div>if present days is 6 ≤ present ≤ 8 then eligible days = 2</div>
        <div>if present days is 9 ≤ present ≤ 11 then eligible days = 3</div>
        <div>if present days is 12 ≤ present ≤ 14 then eligible days = 4</div>
        <div>if present days is 15 ≤ present ≤ 18 then eligible days = 5</div>
        <div>if present days is 19 ≤ present ≤ 21 then eligible days = 6</div>
        <div>if present days is 22 ≤ present ≤ 27 then eligible days = 7</div>
      </>
    );

    return null;
  };

  return (
    <PayRollLayoutWrapper>
      <ToastContainer
        position="top-right"
        autoClose={2800}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        theme={isDark ? "dark" : "light"}
      />

      <div className={`min-h-screen p-6 ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={<span className="font-dmserif text-3xl">MANAGEMENT LEAVE CALCULATION VIEW</span>}
          setSkin={setSkin}
          currentSkin={skin}
        />

        <div
          className={`mx-auto max-w-5xl p-6 mt-6 rounded-3xl shadow-2xl border ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
              : `${currentSkin.glass} bg-white text-black border-gray-200`
          }`}
        >
          <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
            <div className="text-xl font-extrabold">Formula View</div>
            <div className={`px-4 py-2 rounded-2xl text-sm font-bold ${isDark ? "bg-blue-900/40 text-blue-100" : "bg-blue-100 text-blue-800"}`}>
              {screenBadge}
            </div>
          </div>

          <div className={cardBase + " p-6"}>
            {loading ? (
              <div className={textBase}>Loading...</div>
            ) : !meta ? (
              <div className={textBase}>No data</div>
            ) : (
              <div className={`space-y-4 leading-7 ${textBase}`}>
                <div className="text-lg font-bold">
                  Formula for <span className={`${primaryBtnClass} text-white px-3 py-1 rounded-xl`}>{meta.monthName}</span>
                  {" "} - {" "}
                  <span className={`${primaryBtnClass} text-white px-3 py-1 rounded-xl`}>{meta.year}</span>
                </div>

                <div>
                  Sundays = <b>{meta.sundays}</b> / Days in the Month - <b>{meta.daysInMonth}</b>
                </div>

                <div>
                  In a Month - SUNDAY = <b>{meta.sundays}</b> / Conditions for “H” and “L”:
                </div>

                <div className={`rounded-2xl border p-4 ${isDark ? "border-white/10 bg-white/5" : "border-gray-200 bg-gray-50"}`}>
                  {renderRulesPanel() || (
                    <div>No matching formula panel for Sundays={meta.sundays}, Days={meta.daysInMonth}</div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </PayRollLayoutWrapper>
  );
};

export default ManagementLeaveCalculationView;